import { Capacitor } from '@capacitor/core';

export function useCapacitor() {
  const isCapacitor = Capacitor.isNativePlatform();

  return {
    isCapacitor,
  };
}
